<template>
  <aside id="slider" class="main-sidebar control-sidebar-dark">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul data-widget="tree" class="sidebar-menu">
        <slide-item
          v-for="(item,index) in menus"
          :data="item"
          :key="index"
          :type="item.type"
          :isHeader="item.isHeader"
          :icon="item.icon"
          :name="item.name"
          :badge="item.badge"
          :items="item.items"
          :router="item.router"
          :link="item.link"
        >
        </slide-item>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import {mapGetters} from 'vuex'
import SlideItem from './SlideItem'
import Utils from '../common/utils'

export default {
  name: 'va-slider',
  data () {
    return {
      menus: []
    }
  },
  mounted () {
    this.menus = this.menu.menus.filter(item => {
      return this.currentUser.menu_permissions.includes(item.key) && this.showItem(item)
    })
  },
  methods: {
    showItem (item) {
      return Utils.showMenuItem(item)
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'menu'
    ])
  },
  components: {
    'slide-item': SlideItem
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider.vue